<ngx-loading
  [show]="loading"
  [config]="{ backdropBorderRadius: '14px' }"
></ngx-loading>

<div class="page">
  <div class="container blog">
    <p class="pageTitle">Blog</p>

    <div class="blogButtons">

      <p (click)="changeFilter(1)" [style.backgroundColor]="type==1 ? '#56a7d8' : ''"
      [style.color]="type==1 ? 'white' : '#4d4d4d'" class="blogCTA SuccessStories">
      News Features
    </p>

      <p (click)="changeFilter(0)" [style.backgroundColor]="type==0 ? '#ec3c26' : ''"
        [style.color]="type==0 ? 'white' : '#4d4d4d'" class="blogCTA Announcements">
        Blog Posts
      </p>
     
    </div>

    <div *ngIf="filteredNewsLetters && filteredNewsLetters.length>0" class="blogCards">
      <a target="_blank" [href]="filteredNewsLetters[0].redirectTo" class="bigBlogCard">
        <div class="bigBlogCardInfo">

          <p *ngIf="filteredNewsLetters[0].newsletterTypeID==1" [style.color]="'#56A7D8'" class="cardType">
            News Features
          </p>

          <p *ngIf="filteredNewsLetters[0].newsletterTypeID==0" [style.color]="'#EC3C26'" class="cardType">
            Blog Posts
          </p>
        

          <p  *ngIf="filteredNewsLetters[0].lang=='en'" class="cardName">{{ filteredNewsLetters[0].title }}</p>
          <p  style="text-align: right;" dir="rtl" *ngIf="filteredNewsLetters[0].lang=='ar'" class="cardName">{{ filteredNewsLetters[0].titleAr }}</p>
          <p dir="ltr" class="cardDate">{{ dateDisplay(filteredNewsLetters[0].newsletterDate) }}</p>
        </div>


          <img [src]="filteredNewsLetters[0].imageUrl" />
      </a>


      <a target="_blank" [href]="filteredNewsLetters[1].redirectTo" *ngIf="filteredNewsLetters && filteredNewsLetters.length==2" dir="rtl" class="bigBlogCard">
        <div class="bigBlogCardInfo">

          <p  *ngIf="filteredNewsLetters[1].newsletterTypeID==1" [style.color]="'#56A7D8'" class="cardType">
            News Features
          </p>

          <p *ngIf="filteredNewsLetters[1].newsletterTypeID==0" [style.color]="'#EC3C26'" class="cardType">
            Blog Posts
          </p>
       

          <p dir="ltr" style="text-align: left;" *ngIf="filteredNewsLetters[1].lang=='en'" class="cardName">{{ filteredNewsLetters[1].title }}</p>
          <p style="text-align: right;" dir="rtl" *ngIf="filteredNewsLetters[1].lang=='ar'" class="cardName">{{ filteredNewsLetters[1].titleAr }}</p>
          <p dir="ltr" class="cardDate">{{ dateDisplay(filteredNewsLetters[1].newsletterDate) }}</p>
        </div>
        <img [src]="filteredNewsLetters[1].imageUrl" />
      </a>


      <div *ngIf="filteredNewsLetters && filteredNewsLetters.length>2" class="smallBlogCards" [ngClass]="filteredNewsLetters.length == 3 ? 'smallBlogCards2' :  'smallBlogCards3'">
        <a [href]="elm.redirectTo" target="_blank" *ngFor="let elm of filteredNewsLetters | slice:1" class="smallBlogCard">
          <div class="smallBlogCardInfo">

            <p *ngIf="elm.newsletterTypeID==1" [style.color]="'#56A7D8'" class="cardType">
              News Features
            </p>

            <p *ngIf="elm.newsletterTypeID==0" [style.color]="'#EC3C26'" class="cardType">
              Blog Posts
            </p>
         
            <p *ngIf="elm.lang=='en'" class="cardName">{{ elm.title }}</p>
            <p  style="text-align: right;" dir="rtl" *ngIf="elm.lang=='ar'" class="cardName">{{ elm.titleAr }}</p>
            <p dir="ltr" class="cardDate">{{ dateDisplay(elm.newsletterDate) }}</p>
           
          </div>
          <div class="cardImage">
            <img [src]="elm.imageUrl" />
          </div>
         
        </a>


      


      </div>


    </div>

  </div>
</div>